import { UnitOfStudy } from "./AcademicEmailComposerForm.Types";
import { EmailTemplate } from "../../models/notification";
import { EmailPreview } from "../../components/EmailPreview";
import { useNavigate } from "react-router-dom";

interface AcademicEmailComposerFormThankYouProps {
  unitOfStudy: UnitOfStudy;
  faculty: string;
  emailTemplate: EmailTemplate;
  getEmailTemplateVariables: (values: any) => any;
  formValues: any;
  reset: any;
  setShowThankYou: (value: boolean) => void;
  setCurrentStep: (step: number) => void;
}

const AcademicEmailComposerFormThankYou = ({
  faculty,
  emailTemplate = { html: "", name: "", subject: "", text: "" },
  getEmailTemplateVariables,
  formValues = {},
  reset,
  setShowThankYou,
  setCurrentStep,
}: AcademicEmailComposerFormThankYouProps) => {
  const navigate = useNavigate();

  const handleOnClickStatus = () => {
    navigate("/academic-email-status");
  };
  const handleOnClickComposeNew = () => {
    reset();
    setCurrentStep(1);
    setShowThankYou(false);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex flex-1 flex-col gap-4 mt-8 items-center">
        <h1 className="text-[32px]">Thank you!</h1>
        <p className="text-neutral-800">
          This email is now scheduled to be sent
          {/*<span className="font-[ApercuProBold]">9:00am, 07/03/2025</span>*/}
        </p>
      </div>
      <div className="flex flex-1 flex-col mt-8 bg-white p-8 rounded-lg shadow-lg w-[90%] text-[14px]">
        <div className="flex flex-1 flex-nowrap pb-3 border-b font-[ApercuProBold]">
          {formValues.subject}
        </div>
        <div className="flex gap-4 pt-6 items-center">
          <img
            src="/images/user.png"
            alt={faculty}
            className="h-[24px] w-[24px]"
          />
          {faculty}
        </div>
        <div className="flex gap-4 pt-6 items-center">
          <img
            src="/images/info.png"
            alt={faculty}
            className="h-[24px] w-[24px]"
          />
          {emailTemplate.name}
        </div>
        <div className="flex gap-4 pt-6 items-center">
          {formValues && (
            <EmailPreview
              emailTemplate={emailTemplate}
              emailTemplateVariables={getEmailTemplateVariables(formValues)}
              useEditorStyle={false}
            />
          )}
        </div>
      </div>
      <div className="flex flex-1 flex-row gap-4 mt-8 w-[90%]">
        <button
          onClick={handleOnClickComposeNew}
          className="font-[ApercuProBold] text-[16px] flex flex-1 bg-white rounded-md shadow-lg p-4 items-center justify-center"
        >
          Compose a New Email
        </button>
        <button
          onClick={handleOnClickStatus}
          className="flex flex-1 bg-black/75 text-white rounded-md shadow-lg p-4 items-center justify-center font-[ApercuProBold] text-[16px]"
        >
          Status
        </button>
      </div>
    </div>
  );
};

export default AcademicEmailComposerFormThankYou;
